import React, {useEffect, useState} from 'react';
import Accordion from 'react-bootstrap/Accordion';
import {useApiService} from "../../context/ApiServiceContext";
import FAQ from '../../models/FAQ';
import SkeletonLoader from '../SkeletonLoader';

// Scoped since FAQs grew sections: an unfiltered list would drop the AI Mentions
// questions into the homepage accordion. Documents written before sections
// existed read as homepage ones, so this is the same set as before.
export const HOMEPAGE_FAQ_URL = '/faq/list?section=homepage&per_page=100';

export const FAQAccordion: React.FC = () => {
    const [faqs, setFaqs] = useState<FAQ[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const apiService = useApiService();

    useEffect(() => {
        apiService.api.get(HOMEPAGE_FAQ_URL)
            .then(response => {
                setFaqs(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.error("Fetching FAQs failed", error);
                setIsLoading(false);
            });
    }, [apiService]);

    if (isLoading) {
        return <SkeletonLoader amount={1} marginTop/>;
    }

    return (
        <div className="faq-accordion">
            <Accordion defaultActiveKey={faqs[0]?.id}>
                {faqs.map((faq) => (
                    <Accordion.Item eventKey={faq.id} key={faq.id}>
                        <Accordion.Header>{faq.title}</Accordion.Header>
                        <Accordion.Body><p style={{
                            whiteSpace: "pre-line"
                        }} dangerouslySetInnerHTML={{__html: faq.description ?? ''}}></p></Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </div>
    );
};

export default FAQAccordion;
